import styled from '@emotion/styled'

const Container = styled.div`
  --size: 100%;

  & {
    font-size: var(--fs-300);
    font-weight: 500;
    text-align: center;
    position: relative;
    cursor: pointer;
    color: ${({ theme }) => theme.colors.primary[400]};
    padding: 0;
    border: none;
    height: var(--size);
    min-width: 160px;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: ${({ theme }) => theme.style.transitionTime[400]} opacity;
  }

  // &.not-selected {
  //   color: ${({ theme }) => theme.colors.secondary[900]};
  // }

  &:hover {
    opacity: ${({ theme }) => theme.style.opacity[700]};
  }

  &:focus {
    opacity: ${({ theme }) => theme.style.opacity[500]};
  }

  & > figure {
    overflow: hidden;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 8px;
    z-index: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .anchor-underline {
    border: none;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
  }
`

export default Container
